<template>
  <TemplateClient :subtitle="$t('client.recommerce.title')" :hide-back="true">
      <template v-slot:top>
          <PageBackWithLink :to="{name: 'client', params: {id: client.id }}" :text="$t('global.back')"/>
      </template>
      <CheckerboardContainer v-if="client">
      <div
        v-for="(item, i) in allowed"
        :key="i"
        @mousedown="item.newFeature && markFeatureSeen(item.newFeature)"
      >
        <CheckerboardItem
          :title="$t(item.title)"
          title-size="s"
          :route="{ name: item.route }"
          :image="item.icon"
          :smalltext="item.smalltext ? $t(item.smalltext) : undefined"
          :smalltext-color="item.smalltextColor"
        />
      </div>
    </CheckerboardContainer>
  </TemplateClient>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import CheckerboardContainer from "@/components/ui/checkerboard/Checkerboard";
import CheckerboardItem from "@/components/ui/checkerboard/CheckerboardItem";
import TemplateClient from "@/components/templates/TemplateClient";
import PageBackWithLink from '@/components/ui/page/PageBackWithLink';

const SEEN_FEATURES_STORAGE_KEY = 'faume_seen_features';

export default {
  name: "ClientRecommerce",
  components: { PageBackWithLink, TemplateClient, CheckerboardItem, CheckerboardContainer },
  data() {
    return {
      stores: null,
      list: [
        {
          title: "client.config_text",
          icon: "/img/goldenmetrics/translation.svg",
          route: "client-translations",
        },
        {
          title: "client.config_email",
          icon: "/img/goldenmetrics/email.svg",
          route: "client-recommerce-emails",
          requireAdmin: true,
        },
        {
          title: "client.mailbuilder",
          icon: "/img/goldenmetrics/email.svg",
          route: "client-new-recommerce-emails",
          requireClientInCms: true,
        },
        {
          title: "Collections",
          icon: "/img/goldenmetrics/Shirts.svg",
          route: "client-collections",
          requireClientInCms: true,
        },
        {
          title: "market.btnConfigMarket",
          icon: "/img/goldenmetrics/world.svg",
          route: "client-markets-manager",
          requireAdmin: true,
        },
        {
          title: 'Page builder',
          icon: '/img/goldenmetrics/cms.svg',
          route: 'client-pagebuilder-manager',
        },
        {
          title: 'client.recommerce.discounts',
          icon: '/img/goldenmetrics/sale-icon.svg',
          route: 'client-discounts',
          newFeature: 'discounts',
          smalltextColor: '#3b82f6',
        }
        /*
                 {
                    title: 'client.seo.title',
                    icon: '/img/goldenmetrics/details.svg',
                    route: 'client-seo'
                },
                    {
                    title: 'client.visual_content.title',
                    icon: '/img/goldenmetrics/camera.svg',
                    route: 'client-images'
                },
                {
                    title: 'client.payment.title',
                    icon: '/img/goldenmetrics/payment.svg',
                    route: 'client-payment'
                }
                 */
      ],
    };
  },
  computed: {
    ...mapState(["client", "clientsCms"]),
    ...mapGetters(["roles", "isAdmin", "isClientCms"]),
    isCms() {
      return this.client?.id && this.clientsCms?.length ? this.isClientCms(this.client.id) : false;
    },
    allowed() {
      return this.list.filter((item) => {
        if (item.requireEmptyShopifyUrl && !this.hasEmptyShopifyUrl()) {
          return false;
        }
        if (item.requireClientInCms && !this.isCms) {
          return false;
        }
        if (item.requireAdmin && !this.isAdmin) {
          return false;
        }
        return this.allRoutes
          .find((route) => route.name === item.route)
          ?.roles.find((role) => this.roles.includes(role));
      }).map((item) => ({
        ...item,
        smalltext: item.newFeature && !this.isFeatureSeen(item.newFeature)
          ? 'global.newFeature'
          : null,
      }));
    },
    allRoutes() {
      return this.$router.options.routes.map((route) => ({
        name: route.name,
        roles: route.meta?.roles || [],
      }));
    },
  },
  methods: {
    hasEmptyShopifyUrl() {
      return this.client && this.client.shopifyUrl === "";
    },
    // localStorage map of `featureKey -> true` used to hide the "Nouveau" badge
    // once the user has clicked on a card flagged with `newFeature`.
    readSeenFeatures() {
      try {
        return JSON.parse(localStorage.getItem(SEEN_FEATURES_STORAGE_KEY) || '{}');
      } catch {
        return {};
      }
    },
    isFeatureSeen(key) {
      return !!this.readSeenFeatures()[key];
    },
    markFeatureSeen(key) {
      try {
        const seen = this.readSeenFeatures();
        seen[key] = true;
        localStorage.setItem(SEEN_FEATURES_STORAGE_KEY, JSON.stringify(seen));
      } catch {
        // localStorage may be unavailable (private mode, quota); ignore
      }
    },
  },
};
</script>
